import { createReducer, on } from "@ngrx/store";
import { TimerModel } from "./timer.model";
import { setEndTimer, resetEndTimer } from "./timer.actions";

const initialState: TimerModel = {
  endTimer: 0,
};


export const timerReducer = createReducer(
  initialState,
  on(setEndTimer, (state, { endTimer }) => ({ ...state, endTimer })),
  on(resetEndTimer, (state) => ({ ...state, endTimer: 0 })),
);
